import * as React from 'react'
import UI from '../components/UI/UI'
import Works from '../components/Works/Works'
import { transformResponse } from '../scripts/makeRequest'

const Projects = () => {
  const [projects, setProjects] = React.useState([])

  const makeRequest = async () => {
    const req = await fetch('https://api.github.com/users/N-bred/repos?sort=pushed?direction=asc')
    const res = await req.json()
    setProjects(transformResponse(res))
  }

  React.useEffect(() => {
    makeRequest()
    document.body.style.backgroundColor = '#fff'
  }, [])

  return (
    <div>
      <UI page='projects' title='Projects | Nicolas Caballero'>
        <Works
          gridNumber={3}
          gridSize='block-1-3'
          projectsArray={projects}
          cardWidth='30%'
          minHeight='600px'
          allprojects={true}
        />
      </UI>
    </div>
  )
}

export default Projects
